(function() {
    'use strict';

    angular.module('stats')
        .controller('ProductionLogsController', ProductionLogsController);

    ProductionLogsController.$inject = ['$state', 'productionLogsDataSrvc', 'dateFormatConst', 'momentSrvc', 'datatableDefaultPageSizeValueConst', 'checkSearchSrvc', 'filterQuerySrvc'];

    function ProductionLogsController($state, productionLogsDataSrvc, dateFormatConst, momentSrvc, datatableDefaultPageSizeValueConst, checkSearchSrvc, filterQuerySrvc) {
        var self = this;

        self.loading = true;

        self.pageOpts = {
            count: undefined,
            page: 1,
            pageSize: datatableDefaultPageSizeValueConst
        };

        self.productionLogsRows = [];

        self.productionLogsCols = [
            {
                title: 'Data zdarzenia',
                value: 'created',
                type: 'date',
                orderable: true
            },{
                title: 'Użytkownik',
                value: 'name',
                type: 'text',
                searchable: true,
                orderable: true
            },{
                title: 'Zmieniony proces',
                value: 'changed_object_name',
                type: 'text',
            },
            {
                title: 'NR zamówienia',
                value: 'order_id',
                type: 'text',
                searchable: true,
            },{
                title: 'ID pozycji zamówienia',
                value: 'order_product_id',
                type: 'text',
                searchable: true,
            },{
                title: 'Nr montażu',
                value: 'montage_nr',
                type: 'text',
                searchable: true
            }, {
                title: 'Status przed zmianą',
                value: 'old_values',
                type: 'text',
            }, {
                title: 'Status po zmianie',
                value: 'new_values',
                type: 'text',
            }, {
                title: 'Data rozpoczęcia',
                value: 'start_date',
                type: 'datetime',
            }, {
                title: 'Data zakończenia',
                value: 'end_date',
                type: 'datetime',
            },{
                title: 'Czas',
                value: 'time',
                type: 'text',
            }
        ];

        self.searchQuery = {
            pk: null,
            name: null,
            ordering: null,
            order_id: null,
            order_product_id: null,
            montage_nr: null
        };

        self.dateFormat = dateFormatConst.defaultPythonDate;
        self.maxDate = momentSrvc.dateToStr(momentSrvc.getCurrentDate());
        self.daterangeFilter = {startDate: null, endDate: null};
        self.statusOptions = [];

        self.filterData = {
            production_process: null,
            min_date: null,
            max_date: null
        }

        self.pageChange = pageChange;
        self.onSearchQueryChange = onSearchQueryChange;
        self.changeFilter = changeFilter;

        activate();

        function activate() {
            getLogStatuses();
            self.filterData = filterQuerySrvc.initializeFilterData(self.filterData);
            self.pageOpts = filterQuerySrvc.initializePageOpts(self.pageOpts);
            self.searchQuery = filterQuerySrvc.initializeSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            if (self.filterData.min_date) {
                self.daterangeFilter['startDate'] = moment(self.filterData.min_date, 'DD.MM.YYYY');
                self.daterangeFilter['endDate'] = moment(self.filterData.max_date, 'DD.MM.YYYY');
            }
            getProductionLogs();
        }

        function getLogStatuses() {
            productionLogsDataSrvc.statuses().$promise.then(
                function (response){
                    self.statusOptions = response;
                },
                function (response){}
            )
        }

        function getProductionLogs(filterObj) {
            self.loading = true;

            if (!filterObj) {
                filterObj = {
                    page: self.pageOpts.page,
                    page_size: self.pageOpts.pageSize,

                    pk: self.searchQuery.pk,
                    name: self.searchQuery.name,
                    ordering: self.searchQuery.ordering,
                    order_id: self.searchQuery.order_id,
                    order_product_id: self.searchQuery.order_product_id,
                    montage_nr: self.searchQuery.montage_nr,

                    min_date: self.filterData.min_date || null,
                    max_date: self.filterData.max_date || null,
                    production_process: self.filterData.production_process || null
                }
            }
            productionLogsDataSrvc.list(filterObj).$promise
                .then(
                    function (response) {
                        self.productionLogsRows = response.results;
                        self.pageOpts.count = response.count;
                    },
                    function (response) {
                        if (response.status === 404 && filterObj.page !== 1) {
                            checkSearchSrvc.recall(filterObj, getProductionLogs);
                        }
                    }
                )
                .finally(
                    function(response) {
                        self.loading = false;
                        return response;
                    }
                );
            productionLogsDataSrvc.summary(filterObj).$promise.then(
                function (response){
                    self.summary = response;
                },
                function (response){}
            )
        }

        function pageChange() {
            filterQuerySrvc.updatePageOpts(self.pageOpts);
            filterQuerySrvc.setLocationParams();
            getProductionLogs();
        }

        function onSearchQueryChange() {
            filterQuerySrvc.updateSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            getProductionLogs();
        }

        function changeFilter() {
            if (self.daterangeFilter.startDate) {
                self.filterData.min_date = self.daterangeFilter.startDate.format(dateFormatConst.backendDate);
                self.filterData.max_date = self.daterangeFilter.endDate.format(dateFormatConst.backendDate)
            } else {
                self.filterData.min_date = null;
                self.filterData.max_date = null;
            }
            filterQuerySrvc.updateFilterData(self.filterData);
            filterQuerySrvc.setLocationParams();
            getProductionLogs();
        }
    }
})();
